
export default {
  person: {
    name:'张三',
    hobby:'唱跳，rap，篮球',
    登录:'登录',
    密码:'密码',
    首页:'工作台',
    系统管理:'系统管理',
    菜单设置:'菜单设置',
    序号:'序号',
    全部数据权限:'全部数据权限',
    启用:'启用',
    排序编码:'排序编码',
    角色名称:'角色名称',
    机构级别:'机构级别',
    数据权限:'数据权限',
    请选择组织架构:'请选择组织架构',
    新增:'新增',
    中心:'中心',
    用户账号:'用户账号',
    详细地址:'详细地址',
    中国:'中国',
  },
};
